<div class="position-relative h-100 {{options.cssClass}}">
    <ng-container *ngFor="let item of layoutNode.items">
        <div class="{{item.options.outerCssClass === '' ? 'col' : item.options.outerCssClass}}">
            <cv-schema-render-component [layoutNode]="item" [data]="data"></cv-schema-render-component>
        </div>
    </ng-container>
</div>